import { observer } from 'mobx-react-lite';
import React from 'react';
import styled from 'styled-components';

import { useConfig, useSubHeaderScopeRenderer } from '../../hooks';
import Notification from '../Notification';

const SubHeader = () => {
  const {
    window: { fontFamily, colors },
    subheader
  } = useConfig();
  const [subHeaderScopeItems, setSubHeaderScopeItems] = React.useState([]);
  const hasSubHeaderScopeItems = subHeaderScopeItems.length > 0;
  const renderer = useSubHeaderScopeRenderer();

  React.useEffect(() => {
    if (subheader && subheader.scope && Array.isArray(subheader.scope.items)) {
      setSubHeaderScopeItems(subheader.scope.items);
    }
  }, [subheader]);

  return (
    <Root textFontFamily={fontFamily} background={subheader.scope.style.background}>
      {hasSubHeaderScopeItems && (
        <SubHeaderItems align={subheader.scope.style.align} color={subheader.scope.style.color}>
          {subHeaderScopeItems.sort((a, b) => a.position - b.position).map(renderer)}
        </SubHeaderItems>
      )}

      {/* TODO: Select notification */}
      {/* <Notification type={2} colors={colors} /> */}
      {/* <Notification type={3} text="Error notification" colors={colors} /> */}
      {/* <Notification text="Info notification" colors={colors} /> */}
    </Root>
  );
};

const Root = styled.div`
  width: 100%;
  font-family: ${({ textFontFamily }) => textFontFamily};
  background: ${props => props.background};
  border-bottom: 1px solid #fff;
`;

const SubHeaderItems = styled.div`
  display: flex;
  justify-content: ${props => {
    switch (props.align) {
      case 'center':
        return 'center';
      case 'left':
        return 'flex-start';
      case 'right':
        return 'flex-end';
      case 'between':
        return 'space-between';
      case 'around':
        return 'space-around';
      default:
        return 'initial';
    }
  }};
  padding: 10px;
  align-items: center;
  color: ${props => props.color};
  background: inherit;
  width: 100%;
  flex-wrap: wrap;
`;

export default observer(SubHeader);
